import React from 'react';
import {
  Typography,
  Grid,
  Chip,
  Card,
  CardContent,
  Box,
  Divider,
  makeStyles,
} from '@material-ui/core';
import { Role } from 'lib/Model/Permission';

const useStyles = makeStyles((theme) => ({
  roleCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  roleCardContent: {
    flexGrow: 1,
  },
  roleTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  superuserChip: {
    marginLeft: theme.spacing(1),
  },
  permissionsSection: {
    marginTop: theme.spacing(1),
  },
  permissionChips: {
    marginTop: theme.spacing(1),
  },
  chip: {
    margin: theme.spacing(0.25),
    fontSize: '0.75rem',
  },
  clickableCard: {
    cursor: 'pointer',
    transition: theme.transitions.create(['box-shadow', 'transform'], {
      duration: theme.transitions.duration.short,
    }),
    '&:hover': {
      boxShadow: theme.shadows[4],
      transform: 'translateY(-2px)',
    },
  },
}));

interface RolesTabProps {
  rolesData: Role[] | undefined;
  onRoleClick: (roleSlug: string) => void;
}

const RolesTab: React.FC<RolesTabProps> = ({ rolesData, onRoleClick }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      {rolesData?.map((role) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={role.id}>
          <Card
            className={`${classes.roleCard} ${classes.clickableCard}`}
            onClick={() => onRoleClick(role.slug)}
          >
            <CardContent className={classes.roleCardContent}>
              <Box className={classes.roleTitle}>
                <Typography variant="h6" component="h3">
                  {role.name}
                </Typography>
                {role.is_superuser && (
                  <Chip
                    label="Superuser"
                    color="primary"
                    size="small"
                    className={classes.superuserChip}
                  />
                )}
              </Box>
              <Typography variant="body2" color="textSecondary">
                {role.description}
              </Typography>
              <Divider className={classes.permissionsSection} />
              <Box className={classes.permissionChips}>
                {role.permissions.length > 0 ? (
                  role.permissions.map((permission, idx) => (
                    <Chip
                      key={idx}
                      label={permission}
                      size="small"
                      className={classes.chip}
                      color="primary"
                    />
                  ))
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No specific permissions (Superuser access)
                  </Typography>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default RolesTab;
